// extracted by mini-css-extract-plugin
export var header = "_by-0";